import { IndexSort } from "@omni/types/api/search/algolia/shared/enum/indexSort.enum";

import { DefaultHitsPerPage } from "@/components/Search/SearchResults/components/results/components/productsResults/components/resultsView/components/filters/components/productHitsPerPage/hitsPerPage.config";
import {
    SearchComponent,
    SearchComponentEnum
} from "@/utils/search/types/searchComponent";
import { SearchComponentConfigurationMap } from "@/utils/search/types/searchConfiguration";

const defaultConfiguration: SearchComponentConfigurationMap = {
    [SearchComponent.PRODUCT_RESULT_LIST]: {
        component: SearchComponent.PRODUCT_RESULT_LIST
    },
    [SearchComponent.PRODUCT_HITS_PER_PAGE]: {
        component: SearchComponent.PRODUCT_HITS_PER_PAGE,
        hitsPerPage: DefaultHitsPerPage
    },
    [SearchComponent.PRODUCT_PAGINATION]: {
        component: SearchComponent.PRODUCT_PAGINATION,
        hitsWithInjected: 0,
        hitsWithoutInjected: 0
    },
    [SearchComponent.PRODUCT_NUMBER_OF_HITS]: {
        component: SearchComponent.PRODUCT_NUMBER_OF_HITS
    },
    [SearchComponent.PRODUCT_FACETS]: {
        component: SearchComponent.PRODUCT_FACETS,
        facetFilters: [],
        numericFilters: []
    },
    [SearchComponent.PRODUCT_SORT]: {
        component: SearchComponent.PRODUCT_SORT,
        sortBy: IndexSort.Default
    },
    [SearchComponent.CONTENT_RESULT_LIST]: {
        component: SearchComponent.CONTENT_RESULT_LIST
    },
    [SearchComponent.CONTENT_NUMBER_OF_HITS]: {
        component: SearchComponent.CONTENT_NUMBER_OF_HITS
    },
    [SearchComponent.CONTENT_PAGINATION]: {
        component: SearchComponent.CONTENT_PAGINATION,
        hitsWithInjected: 0,
        hitsWithoutInjected: 0
    },
    [SearchComponent.CONTENT_HITS_PER_PAGE]: {
        component: SearchComponent.CONTENT_HITS_PER_PAGE,
        hitsPerPage: DefaultHitsPerPage
    }
};

const getDefaultConfiguration = () => structuredClone(defaultConfiguration);

const getDefaultComponentConfiguration = (component: SearchComponentEnum) =>
    structuredClone(defaultConfiguration[component]);

const getDefaultConfigurationValues = () => Object.values(defaultConfiguration);

export {
    getDefaultComponentConfiguration,
    getDefaultConfiguration,
    getDefaultConfigurationValues
};
